module.exports = __webpack_public_path__ + "static/img/aepic-26.91e14d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-26.jpg
// module id = /MHH
// module chunks = 52